import React, { Fragment, useState } from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import EnrollLineChart from '../../components/enroll-linechart';

export default function Enrollment() {
  return (
    <Grid container spacing={3}>
      {/* EnrollmentChart */}
      <Grid item xs={12} md={12} lg={12}>
        <Paper
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            height: 600,
          }}
        >
          <EnrollLineChart chartTitle='Enrollment Trends' />
        </Paper>
      </Grid>
    </Grid>
  );
}
